var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header1", { attrs: { title: "用户注册" } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "new_content",
          staticStyle: { background: "#FFFFFF", width: "1002px" }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              staticStyle: {
                padding: "30px",
                border: "2px #F1F1F1 solid",
                color: "#5F5F5F",
                "font-size": "14px"
              },
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "90px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "证件类型", prop: "cardType" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择证件类型" },
                      model: {
                        value: _vm.form.cardType,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "cardType", $$v)
                        },
                        expression: "form.cardType"
                      }
                    },
                    _vm._l(_vm.cardTypeOptions, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.value, value: item.key }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "46%" },
                  attrs: { label: "证件号", prop: "sertId" }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入18位证件号" },
                    model: {
                      value: _vm.form.sertId,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "sertId", $$v)
                      },
                      expression: "form.sertId"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "46%" },
                  attrs: { label: "用户名", prop: "username" }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "用户名为6-20个字符，且字母在首位" },
                    model: {
                      value: _vm.form.username,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "username", $$v)
                      },
                      expression: "form.username"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "no_margin_bottom",
                  staticStyle: { width: "48%" },
                  attrs: {
                    "show-message": false,
                    label: "密码",
                    prop: "password"
                  }
                },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        maxLength: 16,
                        type: _vm.form.showPassword ? "text" : "password",
                        autocomplete: "new-password",
                        placeholder: "请输入符合规则的密码"
                      },
                      model: {
                        value: _vm.form.password,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "password",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.password"
                      }
                    },
                    [
                      _c("i", {
                        class: [
                          "el-input__icon",
                          _vm.form.showPassword
                            ? "ri-eye-fill"
                            : "ri-eye-off-fill"
                        ],
                        attrs: { slot: "suffix" },
                        on: {
                          click: function($event) {
                            _vm.form.showPassword = !_vm.form.showPassword
                          }
                        },
                        slot: "suffix"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form_password_verifiers" },
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm
                              .PasswordLengthRge()
                              .test(_vm.form.password)
                              ? "success"
                              : "info",
                            hit: ""
                          }
                        },
                        [
                          _c("i", { staticClass: "el-icon-success" }),
                          _vm._v("8-16位之间\n          ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm
                              .UppercaseLowercaseReg()
                              .test(_vm.form.password)
                              ? "success"
                              : "info",
                            hit: ""
                          }
                        },
                        [
                          _c("i", { staticClass: "el-icon-success" }),
                          _vm._v("含大小写字母\n          ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.NumberReg().test(_vm.form.password)
                              ? "success"
                              : "info",
                            hit: ""
                          }
                        },
                        [
                          _c("i", { staticClass: "el-icon-success" }),
                          _vm._v("含数字\n          ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm
                              .SpecialCharactersReg()
                              .test(_vm.form.password)
                              ? "success"
                              : "info",
                            hit: ""
                          }
                        },
                        [
                          _c("i", { staticClass: "el-icon-success" }),
                          _vm._v("含特殊字符，如:@#*\n          ")
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "48%" },
                  attrs: { label: "确认密码", prop: "vpassword" }
                },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        type: _vm.form.showVpassword ? "text" : "password",
                        autocomplete: "new-password",
                        placeholder: "请再一次输入密码"
                      },
                      model: {
                        value: _vm.form.vpassword,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "vpassword",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.vpassword"
                      }
                    },
                    [
                      _c("i", {
                        class: [
                          "el-input__icon",
                          _vm.form.showVpassword
                            ? "ri-eye-fill"
                            : "ri-eye-off-fill"
                        ],
                        attrs: { slot: "suffix" },
                        on: {
                          click: function($event) {
                            _vm.form.showVpassword = !_vm.form.showVpassword
                          }
                        },
                        slot: "suffix"
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "100%" },
                  attrs: { label: "真实姓名", prop: "realname" }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder:
                                "请输入有效证件上的姓名，不要使用空格"
                            },
                            model: {
                              value: _vm.form.realname,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "realname", $$v)
                              },
                              expression: "form.realname"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { "padding-left": "5px" },
                              attrs: { type: "text" }
                            },
                            [_vm._v(" ※颁发证书时将使用此名字，请如实填写！")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "性别", prop: "sex" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.sex,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "sex", $$v)
                        },
                        expression: "form.sex"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [_vm._v("男")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "0" } }, [_vm._v("女")])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.form.isCustomComp,
                      expression: "!form.isCustomComp"
                    }
                  ],
                  attrs: { label: "所在单位", prop: "company" }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                loading: _vm.compLoading,
                                "no-data-text": _vm.compPrompt,
                                "remote-method": _vm.remoteSearchComp,
                                filterable: "",
                                placeholder: "请输入关键词",
                                remote: ""
                              },
                              model: {
                                value: _vm.form.company,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "company", $$v)
                                },
                                expression: "form.company"
                              }
                            },
                            _vm._l(_vm.compOptions, function(item) {
                              return _c(
                                "el-option",
                                {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { float: "left" } },
                                    [_vm._v(_vm._s(item.name))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        float: "right",
                                        color: "#8492A6",
                                        "font-size": "13px",
                                        "margin-left": "10px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatRegion(
                                            item.province,
                                            item.city,
                                            item.county,
                                            item.rural
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c(
                            "el-popover",
                            {
                              ref: "popover1",
                              attrs: {
                                placement: "top",
                                trigger: "hover",
                                width: "200"
                              },
                              model: {
                                value: _vm.customCompVisible,
                                callback: function($$v) {
                                  _vm.customCompVisible = $$v
                                },
                                expression: "customCompVisible"
                              }
                            },
                            [
                              _c(
                                "p",
                                [
                                  _vm._v(
                                    "搜索单位时无需填写省市县名称，只需填写医院关键字即可，或者可以选择\n                "
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showCustomComp()
                                        }
                                      }
                                    },
                                    [_vm._v("切换自填单位")]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.searchCount >= 5,
                                  expression: "searchCount>=5"
                                },
                                {
                                  name: "popover",
                                  rawName: "v-popover:popover1",
                                  arg: "popover1"
                                }
                              ],
                              attrs: { type: "text" }
                            },
                            [_vm._v(" 找不到单位？")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.isCustomComp,
                      expression: "form.isCustomComp"
                    }
                  ],
                  attrs: { label: "自填单位", prop: "company" }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "", placeholder: "省" },
                              on: { change: _vm.changeArea },
                              model: {
                                value: _vm.form.customCompForm.province,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.customCompForm,
                                    "province",
                                    $$v
                                  )
                                },
                                expression: "form.customCompForm.province"
                              }
                            },
                            _vm._l(_vm.provinceOptions, function(item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.value, value: item.key }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "", placeholder: "市" },
                              on: { change: _vm.changeArea },
                              model: {
                                value: _vm.form.customCompForm.city,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.customCompForm, "city", $$v)
                                },
                                expression: "form.customCompForm.city"
                              }
                            },
                            _vm._l(_vm.cityOptions, function(item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.value, value: item.key }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "", placeholder: "县" },
                              on: { change: _vm.changeArea },
                              model: {
                                value: _vm.form.customCompForm.county,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.customCompForm,
                                    "county",
                                    $$v
                                  )
                                },
                                expression: "form.customCompForm.county"
                              }
                            },
                            _vm._l(_vm.countyOptions, function(item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.value, value: item.key }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "", placeholder: "乡" },
                              model: {
                                value: _vm.form.customCompForm.rural,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.customCompForm,
                                    "rural",
                                    $$v
                                  )
                                },
                                expression: "form.customCompForm.rural"
                              }
                            },
                            _vm._l(_vm.ruralOptions, function(item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.value, value: item.key }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { offset: 1, span: 7 } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "单位名称" },
                            model: {
                              value: _vm.form.customCompForm.compName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.customCompForm,
                                  "compName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.customCompForm.compName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: { click: _vm.swithSelectComp }
                    },
                    [_vm._v("选择已有单位")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "所在科室", prop: "department" } },
                [
                  _c("el-autocomplete", {
                    attrs: {
                      "fetch-suggestions": _vm.searchDepartment,
                      placeholder: "请输入内容"
                    },
                    on: { select: _vm.departmentSelect },
                    model: {
                      value: _vm.form.department,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "department", $$v)
                      },
                      expression: "form.department"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "人员类别", prop: "personType" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择人员类别" },
                      on: { change: _vm.changePersonType },
                      model: {
                        value: _vm.form.personType,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "personType", $$v)
                        },
                        expression: "form.personType"
                      }
                    },
                    _vm._l(_vm.personTypeOptions, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.value, value: item.key }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "专业", prop: "specialty" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择专业1" },
                      on: { change: _vm.changeSpecialtyId1 },
                      model: {
                        value: _vm.form.specialtyId1,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "specialtyId1", $$v)
                        },
                        expression: "form.specialtyId1"
                      }
                    },
                    _vm._l(_vm.specialtyId1Options, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.value, value: item.key }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择专业2" },
                      model: {
                        value: _vm.form.specialtyId2,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "specialtyId2", $$v)
                        },
                        expression: "form.specialtyId2"
                      }
                    },
                    _vm._l(_vm.specialtyId2Options, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.value, value: item.key }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "职称", prop: "title" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择职称" },
                      model: {
                        value: _vm.form.title,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "title", $$v)
                        },
                        expression: "form.title"
                      }
                    },
                    _vm._l(_vm.titleOptions, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.value, value: item.key }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "乡村医生", prop: "countryDoctor" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.form.countryDoctor,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "countryDoctor", $$v)
                        },
                        expression: "form.countryDoctor"
                      }
                    },
                    [
                      _c("el-option", { attrs: { value: 1, label: "是" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { value: 0, label: "否" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "手机号", prop: "mobile" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.verifyShow,
                                  expression: "verifyShow"
                                }
                              ],
                              staticClass: "verifyMain"
                            },
                            [
                              _c("Verify", {
                                ref: "verify",
                                attrs: {
                                  captchaType: "blockPuzzle",
                                  imgSize: {
                                    width: "240px",
                                    height: "120px"
                                  },
                                  mode: "fixed"
                                },
                                on: { success: _vm.success }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.verifyOK,
                                      expression: "verifyOK"
                                    }
                                  ],
                                  staticClass: "verifyOK"
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-success",
                                    staticStyle: {
                                      color: "#67C23A",
                                      "margin-left": "12px",
                                      "margin-right": "8px"
                                    }
                                  }),
                                  _vm._v(
                                    "\n                验证通过\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: { placeholder: "请输入手机号" },
                            model: {
                              value: _vm.form.mobile,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mobile", $$v)
                              },
                              expression: "form.mobile"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 17 } },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "5px" },
                              attrs: { disabled: _vm.sendSmsButtonDisabled },
                              on: { click: _vm.sendSmsMethod }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.sendSmsButtonText) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "短信验证码", prop: "mobileCode" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.mobileCode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mobileCode", $$v)
                              },
                              expression: "form.mobileCode"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 17 } })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticStyle: { "text-align": "center" } },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.agreeContract,
                        expression: "agreeContract"
                      }
                    ],
                    attrs: { required: "", type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.agreeContract)
                        ? _vm._i(_vm.agreeContract, null) > -1
                        : _vm.agreeContract
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.agreeContract,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.agreeContract = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.agreeContract = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.agreeContract = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        "vertical-align": "bottom"
                      }
                    },
                    [
                      _vm._v("\n          已阅读并同意\n          "),
                      _c(
                        "a",
                        {
                          staticStyle: { color: "#38BCD5" },
                          attrs: {
                            href:
                              "https://source.yiboshi.com/licence/0417_shiyan/user.html"
                          }
                        },
                        [_vm._v("《用户协议》")]
                      ),
                      _vm._v("和\n          "),
                      _c(
                        "a",
                        {
                          staticStyle: { color: "#38BCD5" },
                          attrs: {
                            href:
                              "https://source.yiboshi.com/licence/0417_shiyan/pryvacy.html"
                          }
                        },
                        [_vm._v("《保护政策》")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        width: "30%",
                        background: "#1D7A8E",
                        "border-color": "#1D7A8E"
                      },
                      attrs: {
                        disabled: !_vm.agreeContract,
                        loading: _vm.registerLoading,
                        type: "primary"
                      },
                      on: { click: _vm.onSubmit }
                    },
                    [_vm._v(_vm._s(_vm.registerText) + "\n        ")]
                  ),
                  _vm._v(" "),
                  _c("br")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { width: "1002px", margin: "0 auto" } },
        [_c("footer1")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticStyle: {
          height: "40px",
          "padding-left": "20px",
          "line-height": "40px",
          "font-size": "14px",
          "font-weight": "bold"
        }
      },
      [
        _c("span", { staticStyle: { color: "#1D7A8E" } }, [_vm._v("提醒：")]),
        _vm._v(
          "为了保证您第一时间获取培训有效证书，请如实填写以下注册信息，避免重复注册。"
        )
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63ae9146", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63ae9146","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Register.vue
// module id = null
// module chunks = 